export default __webpack_public_path__ + "static/media/card8_left.a769e728.png";